import type { TreatmentPlanV3TabConfig } from './types';

export const TREATMENT_PLAN_V3_TAB_IDS = {
  INFORMATION: 'information',
  MEDICAL: 'medical',
  REFERRAL: 'referral',
  MEDICATION: 'medication',
  THERAPY: 'therapy',
  EDUCATION: 'education',
  FAMILY: 'family',
  CHILD: 'child',
  ASSESSMENT: 'assessment',
  CRISIS: 'crisis',
  GOALS: 'goals',
  DISCHARGE: 'discharge',
  TREATMENT: 'treatment',
} as const;

export const TREATMENT_PLAN_V3_IMPLEMENTED_TAB_IDS = [
  TREATMENT_PLAN_V3_TAB_IDS.INFORMATION,
  TREATMENT_PLAN_V3_TAB_IDS.MEDICAL,
  TREATMENT_PLAN_V3_TAB_IDS.REFERRAL,
  TREATMENT_PLAN_V3_TAB_IDS.MEDICATION,
  TREATMENT_PLAN_V3_TAB_IDS.THERAPY,
  TREATMENT_PLAN_V3_TAB_IDS.EDUCATION,
  TREATMENT_PLAN_V3_TAB_IDS.FAMILY,
  TREATMENT_PLAN_V3_TAB_IDS.CHILD,
  TREATMENT_PLAN_V3_TAB_IDS.ASSESSMENT,
  TREATMENT_PLAN_V3_TAB_IDS.CRISIS,
  TREATMENT_PLAN_V3_TAB_IDS.DISCHARGE,
  TREATMENT_PLAN_V3_TAB_IDS.TREATMENT,
] as const;

export const TREATMENT_PLAN_V3_TAB_CONFIGS: ReadonlyArray<TreatmentPlanV3TabConfig> = [
  { id: TREATMENT_PLAN_V3_TAB_IDS.INFORMATION, label: 'Information' },
  { id: TREATMENT_PLAN_V3_TAB_IDS.MEDICAL, label: 'Medical' },
  { id: TREATMENT_PLAN_V3_TAB_IDS.REFERRAL, label: 'Referral' },
  { id: TREATMENT_PLAN_V3_TAB_IDS.MEDICATION, label: 'Medication' },
  { id: TREATMENT_PLAN_V3_TAB_IDS.THERAPY, label: 'Therapy' },
  { id: TREATMENT_PLAN_V3_TAB_IDS.EDUCATION, label: 'Education' },
  { id: TREATMENT_PLAN_V3_TAB_IDS.FAMILY, label: 'Family' },
  { id: TREATMENT_PLAN_V3_TAB_IDS.CHILD, label: 'Child' },
  { id: TREATMENT_PLAN_V3_TAB_IDS.ASSESSMENT, label: 'Assessment' },
  { id: TREATMENT_PLAN_V3_TAB_IDS.CRISIS, label: 'Crisis' },
  { id: TREATMENT_PLAN_V3_TAB_IDS.GOALS, label: 'Goals' },
  { id: TREATMENT_PLAN_V3_TAB_IDS.DISCHARGE, label: 'Discharge' },
  { id: TREATMENT_PLAN_V3_TAB_IDS.TREATMENT, label: 'Treatment' },
];
